import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const ModalFamily = styled(Modal)`
  
`;

export const Container = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem 2rem;
  font-family: Arial, sans-serif;
  
  h2 {
    font-size: 22px;
  }
`;

export const CategoryItem = styled.div`
  border-bottom: 1px solid #ddd;
  padding: 8px 0;
`;

export const CategoryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
`;

export const ExpandButton = styled.button`
  background: none;
  border: none;
  font-size: 20px !important;
  cursor: pointer;
  color: #007bff;
`;

export const SubcategoryList = styled.ul`
  list-style: none;
  padding-left: 20px;
  margin-top: 5px;
`;

export const SubcategoryItem = styled.li`
  font-size: 14px;
  padding: 3px 0;
  color: #555;
  transition: all 0.3s ease-in-out;
    
  :hover {
    color: #007bff;
    cursor: pointer;
  }
`;

